// Matches [name] in AffordableRelationship table
const AFFORDABLE_RELATIONSHIPS = {
  ADULT_CO_TENANT: 'Adult co-tenant',
  CHILD: 'Child',
  FOSTER_CHILD_ADULT: 'Foster child/adult',
  GUARANTOR: 'Guarantor',
  HEAD_OF_HOUSEHOLD: 'Head of Household',
  LIVE_IN_CARETAKER: 'Live-in Caretaker',
  OTHER_FAMILY_MEMBER: 'Other Family Member',
  SPOUSE: 'Spouse',
  UNBORN_CHILD: 'Unborn Child',
};

export default AFFORDABLE_RELATIONSHIPS;
